import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { ILineItemStyle } from "@faire/retailer-visitor-shared/components/getLineItemColorByStyleAndSurface";
import { getNextOrActiveEvent } from "@faire/retailer-visitor-shared/serialized-data/getNextOrActiveEvent";
import { clock } from "@faire/web--source/common/clock";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { FaireMarketTheme } from "@faire/web--source/slate/Theme/EventsTheme";
import { createStoreHook } from "@faire/web--source/ui/hooks/useStore";
import { ICurrentPromotionalEventResponse } from "@faire/web-api--source/indigofair/data/ICurrentPromotionalEventResponse";
import { utcToZonedTime } from "date-fns-tz";
import isAfter from "date-fns/isAfter";
var PromotionalEventGroup = ICurrentPromotionalEventResponse.IPromotionalEvent.PromotionalEventGroup;
/**
 * @deprecated prefer to use `useEventsStore` or `withStores` instead
 */ export var EventsStore = /*#__PURE__*/ function() {
    "use strict";
    function EventsStore() {
        var _this = this;
        _class_call_check(this, EventsStore);
        this.eventData = function(eventType) {
            var _this_nextOrActive_event, _this_nextOrActive;
            return ((_this_nextOrActive = _this.nextOrActive) === null || _this_nextOrActive === void 0 ? void 0 : (_this_nextOrActive_event = _this_nextOrActive.event) === null || _this_nextOrActive_event === void 0 ? void 0 : _this_nextOrActive_event.event_type) === eventType ? _this.nextOrActive : undefined;
        };
        this.isEventExpired = function(eventType) {
            var _eventData_event;
            var eventData = _this.nextOrActive;
            if (!eventData || (eventData === null || eventData === void 0 ? void 0 : (_eventData_event = eventData.event) === null || _eventData_event === void 0 ? void 0 : _eventData_event.event_type) !== eventType) {
                return true;
            }
            var endAt = eventData.end_at;
            if (endAt === undefined) {
                // assuming an event with undefined end date always live
                return false;
            }
            return isAfter(clock.now(), endAt);
        };
    }
    _create_class(EventsStore, [
        {
            key: "nextOrActive",
            get: function get() {
                return getNextOrActiveEvent();
            }
        },
        {
            key: "isMarketEvent",
            get: function get() {
                var _this_nextOrActive_event, _this_nextOrActive;
                return ((_this_nextOrActive = this.nextOrActive) === null || _this_nextOrActive === void 0 ? void 0 : (_this_nextOrActive_event = _this_nextOrActive.event) === null || _this_nextOrActive_event === void 0 ? void 0 : _this_nextOrActive_event.event_group) === PromotionalEventGroup.MARKET;
            }
        },
        {
            key: "eventLineItemStyle",
            get: function get() {
                return this.isMarketEvent ? ILineItemStyle.MARKET : ILineItemStyle.FAIRE_FASHION_WEEK_DISCOUNT;
            }
        },
        {
            key: "nextOrActiveEventTheme",
            get: function get() {
                var _this_nextOrActive_event, _this_nextOrActive;
                switch((_this_nextOrActive = this.nextOrActive) === null || _this_nextOrActive === void 0 ? void 0 : (_this_nextOrActive_event = _this_nextOrActive.event) === null || _this_nextOrActive_event === void 0 ? void 0 : _this_nextOrActive_event.event_group){
                    case PromotionalEventGroup.MARKET:
                    default:
                        return FaireMarketTheme;
                }
            }
        }
    ]);
    return EventsStore;
}();
EventsStore.get = singletonGetter(EventsStore);
EventsStore.unsnapFromPT = function(timeUtc) {
    return utcToZonedTime(timeUtc, PT_TIMEZONE).valueOf();
};
export var useEventsStore = createStoreHook(EventsStore);
var PT_TIMEZONE = "America/Los_Angeles";
